/** @format */

import { api } from 'utility';
import axios from 'axios';

class BusinessListServices {
  axios;

  source;

  CancelToken;

  constructor() {
    this.CancelToken = axios.CancelToken;
  }

  async getBusinessList(obj) {
    const url = `/business/admin`;

    if (this.source) {
      this.source.cancel();
    }

    this.source = this.CancelToken.source();

    const params = { offset: 0, size: 10, ...obj };

    return api
      .get(url, {
        params,
        cancelToken: this.source.token,
      })
      .then((res) => res.data);
  }
}

const businessListServices = new BusinessListServices();
export default businessListServices;
